exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._3C62-{font-size:18px;color:#008489}._4O7Jw{font-size:48px}._3C62- span{animation-name:_3ZQyr;animation-duration:1.4s;animation-iteration-count:infinite;animation-fill-mode:both;color:#008489}._3C62- span:nth-child(2){animation-delay:.2s}._3C62- span:nth-child(3){animation-delay:.4s}@keyframes _3ZQyr{0%{opacity:.2}20%{opacity:1}to{opacity:.2}}._2D2w9{text-align:center}._2bInx{color:#ff5a5f;font-size:48px}", ""]);

// exports
exports.locals = {
	"saving": "_3C62-",
	"savingDots": "_4O7Jw",
	"blink": "_3ZQyr",
	"textCenter": "_2D2w9",
	"iconColor": "_2bInx"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./~/postcss-loader?{"config":"./tools/postcss.config.js"}!./src/components/Loader/Loader.css
// module id = 2544
// module chunks = 15